import firebase from "firebase";
import { SocialType } from "./social-type";

export const socialProviders = [
  {
    socialType: SocialType.GOOGLE,
    id:"google.com",
    getProvider: () => new firebase.auth.GoogleAuthProvider(),
    icon: "google",
  },
  {
    socialType: SocialType.FACEBOOK,
    id:"facebook.com",
    getProvider: () => new firebase.auth.FacebookAuthProvider(),
    icon: "facebook",
  },
  {
    socialType:SocialType.APPLE,
    id:"apple.com",
    getProvider:()=>new firebase.auth.OAuthProvider('apple.com'),
    icon:"apple"
  }
];
